import { useState, useEffect, useRef, useContext } from 'react';
import { Fab, Typography, Box } from '@mui/material';
import {
  CheckBox as CheckBoxIcon,
  Warning as WarningIcon,
  ArrowUpward as ArrowUpwardIcon,
} from '@mui/icons-material';

import { Button, Grid } from '../../components/common';
import { directPayment } from '../../utils';

import { downloadCSVFile, dataToCSV } from './CSVFunctions';
import FarmContext from '../../store/farm-context';
import CropsStructureTable from './AssesmentScreenCompontents/Tables/CropsStructureTable';
import SubsidiesAmountTable from './AssesmentScreenCompontents/Tables/SubsidiesAmountTable';
import IndividualPlotsCropsTable from './AssesmentScreenCompontents/Tables/IndividualPlotsCropsTable';
import PlotsOwnershipTable from './AssesmentScreenCompontents/Tables/PlotsOwnershipTable';
import AssesmentInfo from './AssesmentScreenCompontents/AssesmentInfo';

function createData(id, name, area, income, fieldPercent, incomePercent) {
  return { id, name, area, income, fieldPercent, incomePercent };
}

export default function AssesmentScreenData(props) {
  const farmCTX = useContext(FarmContext);
  const [dropdownData, setDropdownData] = useState(null);
  const [fieldsData, setFieldsData] = useState(null);
  const [confirmationStatus, setConfirmationStatus] = useState(false);
  const [errorStatus, setErrorStatus] = useState(false);
  const [errorText, setErrorText] = useState();
  const [hideFab, setHideFab] = useState(true);
  const { data } = props;

  const hiddenFileInput = useRef(null);
  const cropsStructureTableRef = useRef(null);
  const cropsStructureTableButtonRef = useRef(null);
  const subsidiesAmountTableRef = useRef(null);
  const individualPlotsCropsTableRef = useRef(null);
  const plotsOwnershipTableRef = useRef(null);

  useEffect(() => {
    if (data) {
      directPayment
        .detailedCrops(data.id, farmCTX.farmID)
        .then(function (result) {
          if (result.status === 403) {
            window.location.href = '/login';
          }
          if (result.data.length > 0) {
          }
          setDropdownData(
            result.data.cropGroupedTerytList.sort((a, b) => a.id - b.id)
          );
        })
        .catch(function (err) {});
      directPayment
        .fields(data.id, farmCTX.farmID)
        .then(function (result) {
          if (result.status === 403) {
            window.location.href = '/login';
          }
          if (result.data.length > 0) {
          }
          setFieldsData(result.data.sort((a, b) => a.id - b.id));
        })
        .catch(function (err) {});
    }
    return () => {
      setDropdownData(null);
      setFieldsData(null);
      setConfirmationStatus(false);
      setErrorStatus(false);
      setErrorText();
    };
    //eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    const onScrollHandler = (e) => {
      if (cropsStructureTableRef.current.getBoundingClientRect().top <= 150)
        setHideFab(false);
      else setHideFab(true);
    };
    document
      .getElementById('dashboard_main')
      .addEventListener('scroll', onScrollHandler);

    return () =>
      document
        .getElementById('dashboard_main')
        .removeEventListener('scroll', onScrollHandler);
  }, []);

  const scrollToTable = (tableRef) => {
    document.getElementById('dashboard_main').scrollTo({
      top:
        tableRef.current.getBoundingClientRect().top +
        document.getElementById('dashboard_main').scrollTop -
        70,
      behavior: 'smooth',
    });
  };

  const scrollToTop = () => {
    document.getElementById('dashboard_main').scrollTo({
      top:
        document.getElementById('dashboard_main').scrollTop +
        cropsStructureTableButtonRef.current.getBoundingClientRect().top -
        75,
      behavior: 'smooth',
    });
  };

  const groupedRows = [];
  let i = 0;
  data.groupedCultivationsList.forEach((cultivation) => {
    if (cultivation.cropArea > 0) {
      i = i + 1;
      groupedRows.push(
        createData(
          i,
          cultivation.cropName,
          Number(cultivation.cropArea.toFixed(2)),
          Number(
            (cultivation.cropArea * cultivation.cropIncomeIndex).toFixed(2)
          ),
          Number(((cultivation.cropArea / data.fieldsArea) * 100).toFixed(2)),
          Number(
            (
              ((cultivation.cropArea * cultivation.cropIncomeIndex) /
                data.productionValue) *
              100
            ).toFixed(2)
          )
        )
      );
    }
  });

  const handleInputClick = (event) => {
    hiddenFileInput.current.click();
  };

  const onChangeHandler = async (event) => {
    await uploadFile(event.target.files[0], data.id);
  };

  const uploadFile = (fileup, id) => {
    const data = new FormData();
    data.append('file', fileup);
    data.append('id', id);
    directPayment
      .confirm(id, farmCTX.farmID, data)
      .then(function (result) {
        if (result.status === 200) {
          setConfirmationStatus(true);
          setErrorStatus(false);
          setErrorText(null);
        }
      })
      .catch(function (err) {
        if (err.response.status === 400) {
          setErrorText('Numery dokumentów nie są zgodne!');
          setErrorStatus(true);
          setConfirmationStatus(false);
        } else if (err.response.status === 500) {
          setErrorText('Błędny format pliku!');
          setErrorStatus(true);
          setConfirmationStatus(false);
        }
      });
  };

  const deleteDirectPayment = async () => {
    const result = await directPayment.deleteByID(data.id, farmCTX.farmID);
    if (result.status === 403) {
      window.location.href = '/login';
    }
    props.setDirectPaymentAvailable(false);
    props.setData('');
  };

  const getDataCSV = () => {
    downloadCSVFile(dataToCSV(data));
  };

  return (
    <>
      <Grid container justifyContent="center" alignItems="center">
        <AssesmentInfo data={data} />

        <Grid item sm={8} md={4} lg={4} xl={4} container>
          <Grid item xs container direction="column">
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                '& .MuiButton-label': {
                  fontWeight: 600,
                },
              }}
              onClick={handleInputClick}
              disabled={confirmationStatus}
              endIcon={
                confirmationStatus && (
                  <CheckBoxIcon
                    sx={{
                      color: '#118553',
                      transform: 'scale(1.75)',
                      marginLeft: 5,
                    }}
                  />
                )
              }
            >
              {confirmationStatus
                ? 'Wniosek o dopłaty potwierdzony'
                : 'Umieść potwierdzenie wniosku o dopłaty'}
            </Button>
            <input
              ref={hiddenFileInput}
              style={{ display: 'none' }}
              id="file"
              type="file"
              name="file"
              onChange={onChangeHandler}
            />
            {errorStatus && (
              <Box p={1} textAlign="center">
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item>
                    <Typography
                      variant="caption"
                      sx={{ fontWeight: 'bold', color: '#e0453a' }}
                    >
                      {errorText}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <WarningIcon
                      sx={{
                        color: '#e0453a',
                        transform: 'scale(1.1)',
                        marginLeft: 10,
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                '& .MuiButton-label': {
                  fontWeight: 600,
                },
              }}
              onClick={getDataCSV}
            >
              Pobierz dane
            </Button>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                '& .MuiButton-label': {
                  fontWeight: 600,
                },
              }}
              onClick={deleteDirectPayment}
            >
              Zresetuj informacje dla danego roku
            </Button>
          </Grid>
        </Grid>

        <Grid
          item
          sm={10}
          md={12}
          container
          direction="row"
          justifyContent="space-between"
          sx={{ mt: 6, mb: 4, px: 5 }}
        >
          <Grid item sm={12} md={6} lg={3} xl={3} container sx={{ px: 3 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => scrollToTable(cropsStructureTableRef)}
              ref={cropsStructureTableButtonRef}
            >
              Struktura upraw
            </Button>
          </Grid>
          <Grid item sm={12} md={6} lg={3} xl={3} container sx={{ px: 3 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => scrollToTable(subsidiesAmountTableRef)}
            >
              Wielkość dopłat
            </Button>
          </Grid>
          <Grid item sm={12} md={6} lg={3} xl={3} container sx={{ px: 3 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => scrollToTable(individualPlotsCropsTableRef)}
            >
              Uprawy na poszczególnych działkach
            </Button>
          </Grid>
          <Grid item sm={12} md={6} lg={3} xl={3} container sx={{ px: 3 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => scrollToTable(plotsOwnershipTableRef)}
            >
              Własność działek
            </Button>
          </Grid>
        </Grid>

        <CropsStructureTable
          cropsStructureTableRef={cropsStructureTableRef}
          groupedRows={groupedRows}
          fieldsArea={data.fieldsArea}
        />
        <SubsidiesAmountTable
          subsidiesAmountTableRef={subsidiesAmountTableRef}
          paymentTypeIncomeList={data.paymentTypeIncomeList}
        />
        <IndividualPlotsCropsTable
          individualPlotsCropsTableRef={individualPlotsCropsTableRef}
          dropdownData={dropdownData}
        />
        <PlotsOwnershipTable
          plotsOwnershipTableRef={plotsOwnershipTableRef}
          fieldsData={fieldsData}
          id={data.id}
          setFieldsData={setFieldsData}
        />
      </Grid>

      {!hideFab && (
        <Fab
          aria-label="fab"
          style={{
            position: 'absolute',
            bottom: 50,
            right: 100,
            color: '#FFFFFF',
            backgroundColor: '#118553',
          }}
          onClick={scrollToTop}
        >
          <ArrowUpwardIcon />
        </Fab>
      )}
    </>
  );
}
